import { Link } from "react-router-dom";
import { Instagram, Facebook } from "lucide-react";

const TikTokIcon = ({ size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V9.01a8.16 8.16 0 0 0 4.77 1.52V7.09a4.84 4.84 0 0 1-1.84-.4z"/>
  </svg>
);

export default function Footer({ settings }) {
  const year = new Date().getFullYear();
  const phone = settings?.phone || "(732) 928-9115";
  const telHref = `tel:${phone.replace(/[^0-9+]/g, "")}`;

  return (
    <footer
      data-testid="site-footer"
      className="bg-[var(--dough)] border-t border-[var(--line)] py-14"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3">
            <img src="/logo-emilios.jpg" alt="Emilio's Restaurant & Pizzeria" className="h-12 w-auto rounded-md" />
          </div>
          <p className="mt-4 text-sm text-[var(--charcoal-soft)] max-w-md leading-relaxed">
            Handmade pizzas, pastas & Italian classics. Family-owned. Serving
            our community with love since 2001.
          </p>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-[var(--charcoal-soft)]">
            Visit
          </div>
          <ul className="mt-4 space-y-2 text-sm text-[var(--charcoal)]">
            <li>{settings?.address || "715 Bennetts Mills Rd, Jackson Township, NJ 08527"}</li>
            <li>
              <a href={telHref} data-testid="footer-call" className="hover:text-[var(--terracotta)]">
                {phone}
              </a>
            </li>
            <li>{settings?.hours || "Mon–Sun: 11:00 AM – 9:00 PM"}</li>
          </ul>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-[var(--charcoal-soft)]">
            Follow
          </div>
          <ul className="mt-4 space-y-2 text-sm text-[var(--charcoal)]">
            {settings?.instagram_url && (
              <li>
                <a
                  href={settings.instagram_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-instagram"
                  className="inline-flex items-center gap-2 hover:text-[var(--terracotta)]"
                >
                  <Instagram size={14} /> Instagram
                </a>
              </li>
            )}
            {settings?.facebook_url && (
              <li>
                <a
                  href={settings.facebook_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-facebook"
                  className="inline-flex items-center gap-2 hover:text-[var(--terracotta)]"
                >
                  <Facebook size={14} /> Facebook
                </a>
              </li>
            )}
            {settings?.tiktok_url && (
              <li>
                <a
                  href={settings.tiktok_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-tiktok"
                  className="inline-flex items-center gap-2 hover:text-[var(--terracotta)]"
                >
                  <TikTokIcon size={14} /> TikTok
                </a>
              </li>
            )}
            <li>
              <Link
                to="/admin/login"
                data-testid="footer-admin-link"
                className="text-[var(--charcoal-soft)] hover:text-[var(--terracotta)]"
              >
                Staff login
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-5 md:px-8 mt-10 pt-6 border-t border-[var(--line)] flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-[var(--charcoal-soft)]">
        <div>© {year} Emilio&apos;s Pizza &amp; Restaurant. All rights reserved.</div>
        <div>Handmade website · Handmade pizza.</div>
      </div>
    </footer>
  );
}
